export default class Norm {
}
